import React from 'react'
import TabNavigation from './SubCategoryTabs';
import './ToolsPanel.css';
import ActiveCalculator from '../../calculators/ActiveCalculator';

const ToolsPanel: React.FC = () => {
	return (
		<div className="tools-panel">
			<TabNavigation />
			<div className="tools-panel__main">
				<ActiveCalculator />
			</div>
		</div>
	)
}

export default ToolsPanel